import { Box } from '@mui/material'
import { startCase } from 'lodash'
import React from 'react'

function Inputs({
  recipeOutput,
}: {
  tableKey: any
  providedInputNames: any
  recipeOutput: any
}) {
  return (
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        overflowY: 'auto',
        padding: 4,
        height: '100%',
        borderBottom: '1px solid #000',
        marginBottom: '8px',
        background: 'white',
      }}
    >
      <table
        style={{
          width: '100%',
          borderCollapse: 'collapse',
        }}
      >
        <tbody>
          {Object.entries(recipeOutput?.provided_input || {})?.map(
            ([key, value], index) => {
              const response =
                value === null
                  ? '-'
                  : Array.isArray(value)
                    ? value.join(', ')
                    : value

              return (
                <tr key={index}>
                  <th style={{ padding: 4, textAlign: 'left', color: '#000' }}>
                    {startCase(key?.replace('_', ' '))}
                  </th>
                  <td style={{ padding: 4, textAlign: 'left', color: '#000' }}>
                    {response}
                  </td>
                </tr>
              )
            },
          )}
        </tbody>
      </table>
    </Box>
  )
}

export default Inputs
